import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface TarifaQuartoData {
  id: number;
  quarto: {
    id: number;
    nome?: string;
    capacidade?: number;
  };
  data: string;
  quantidadeHospedes: number;
  valor: number;
}

export interface TarifaQuartoDataDTO {
  quartoId: number;
  data: string;
  tarifas: {
    [quantidade: number]: number;
  };
}

@Injectable({
  providedIn: 'root'
})
export class TarifaQuartoDataService {

  private readonly apiUrl =
    `${environment.apiUrl}/admin/tarifas-data`;

  constructor(
    private http: HttpClient
  ) {}

  listar(
    quartoId: number
  ): Observable<TarifaQuartoData[]> {

    return this.http.get<TarifaQuartoData[]>(
      `${this.apiUrl}?quartoId=${quartoId}`
    );
  }

  buscarPorId(
    id: number
  ): Observable<TarifaQuartoData> {

    return this.http.get<TarifaQuartoData>(
      `${this.apiUrl}/${id}`
    );
  }

  salvar(
    dto: TarifaQuartoDataDTO
  ): Observable<void> {

    return this.http.post<void>(
      this.apiUrl,
      dto
    );
  }

  editar(
    dto: TarifaQuartoDataDTO
  ): Observable<void> {

    return this.http.put<void>(
      this.apiUrl,
      dto
    );
  }

  excluir(
    id: number
  ): Observable<void> {

    return this.http.delete<void>(
      `${this.apiUrl}/${id}`
    );
  }
}
